/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {bus} from '@/main';
import deactivatedUserForPopup from '@/components/authentication/deactivated-user-for-popup/';
import toast from '@/services/toast';
import userAccountApprovalForPopup from '@/components/authentication/user-account-approval-for-popup/';

export default {
  name: 'main-login-form-popup',
  components: {
    'deactivated-user-for-popup' : deactivatedUserForPopup,
    'user-account-approval-for-popup':userAccountApprovalForPopup
  },
  props: [],
  data () {
    return {
      redirectTo: null,
      redirectToHash: null,
      redirectToHashFull: null,
      password:'',
      identity: '',
      submitted: false,
      loginEmailFieldError:false,
      loginPwFieldError:false,
      attempt:1,
      attemptErrorCount:1,
      loginPopupCross:true,
      showPassword:false,
      userInActiveError:false,
      validationPwErr:false,
      validationEmailErr:false,
      deactivatedUserForPopupState:false,
      userAccountApprovalForPopupState:false
    }
  },
  computed: {

  },
  mounted () {
    this.redirectTo = this.$route.query.redirect;
    this.redirectToHash = this.$route.hash
    this.redirectToHashFull = this.redirectTo + this.redirectToHash
    if(this.$route.name == 'loginMainPage'){
      this.loginPopupCross = false
    }else{
      this.loginPopupCross = true
    }
    bus.$on('deactivatedUserForPopupStateBus', (data) => {
      this.deactivatedUserForPopupState = data;
    });
    bus.$on('userAccountApprovalForPopupStateBus', (data) => {
      this.userAccountApprovalForPopupState = data;
    });
  },
  methods: {
    emailErrorHideMethod(){
      this.loginEmailFieldError = false
      this.userInActiveError = false
      this.validationEmailErr = false
    },
    passwordErrorHideMethod(){
      this.loginPwFieldError = false
      this.userInActiveError = false
      this.validationPwErr = false
    },
    validateLoginBeforeSubmit() {
      this.validationEmailErr = true
      this.validationPwErr = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.attemptErrorCount = this.attempt
          this.$store.dispatch('loginUserWithPwAction', {
            identity: this.identity,
            password: this.password,
            type:'web',
            attempt:this.attempt
            })
            .then((res) => {
              $(".preloader").show()
              this.$store.dispatch('authUserAgreementFun', {
                user: res.data.data.user.email,
                from_page: "login",
              })
              if(this.redirectTo && this.redirectToHash){
                let redirect_login = this.redirectToHashFull.split('/')
                if (redirect_login[redirect_login.lastIndexOf('')] = '') {
                  this.$router.push('/home/');
                } else {
                  this.$router.push({
                    path: this.redirectToHashFull
                  });
                }
              } else {
                this.$router.push('/home/');
              }
              this.loginEmailFieldError = false
              this.loginPwFieldError = false
              toast.success(res.data.msg || 'Request processed successfully.');
            }).catch((err) => {
              this.submitted = false
              console.log(err.data.data, "Checking Errors")
              if(err.data.error.attempt){
                this.attempt = 1
                toast.error(err.data.error.attempt);
                this.loginPwFieldError = true
              }else{
                this.attempt = this.attempt + 1
              }
              if(err.data.error.password){
                this.loginPwFieldError = true
              }
              if(err.data.error.identity){
                this.loginEmailFieldError = true
              }
              if(err.data.data.is_active == false){
                this.userAccountApprovalForPopupState = true;
                document.body.classList.add('popup_open_body');
              }
              if(err.data.data.is_deleted == false){
                this.deactivatedUserForPopupState = true;
                document.body.classList.add('popup_open_body');
              }
              // if(err.data.error == 'Wait for account approval by Admin Lymphomap.'){
              //  this.userInActiveError = true
              // }
            })
          return;
        }
      });
    },
    popupCloseEventMethod(){
      bus.$emit('mainLoginFormPopupStateBus', false);
    }
  }
}